import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCheck, FaStore } from 'react-icons/fa';
import { YPageShell, YPageShellBody, YPageShellHeader } from '../../../ui/shell/YPageShell';
import { YButton } from '../../../ui/YButton';
import SuggestStoreForm, { SUGGEST_STORE_STEPS } from '../../toolkit/components/SuggestStoreForm';
import { SuggestStoreStepper } from '../components/SuggestStoreStepper';
import { isCampEssentialsEnabled } from '../../../utils/featureFlags';
import '../components/suggest-store-shell.css';

const STORE_BROWSE_FALLBACK = '/toolkit/feed-management';

export function SuggestStorePage() {
  const navigate = useNavigate();
  const [submitted, setSubmitted] = useState(false);
  const storeBrowsePath = isCampEssentialsEnabled()
    ? '/camp-essentials/gear'
    : STORE_BROWSE_FALLBACK;

  const handleCancel = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate(storeBrowsePath);
  };

  if (submitted) {
    return (
      <YPageShell testId="suggest-store-page" className="ss-page">
        <YPageShellHeader
          icon={<FaStore size={16} />}
          title="Suggest a Store"
          subtitle="Help grow the feed & seed directory"
        />
        <YPageShellBody>
          <div className="ss-card">
            <div className="ss-card__body">
              <div className="ss-success" data-testid="suggest-store-success">
                <div className="ss-success__icon" aria-hidden="true">
                  <FaCheck />
                </div>
                <h2 className="ss-success__title">Thanks for the suggestion</h2>
                <p className="ss-success__body">
                  Your store submission is in review. Once approved, it will appear in Find a Store
                  across Feed Management and Planting Assistant.
                </p>
                <div className="ss-success__actions">
                  <YButton
                    type="button"
                    variant="primary"
                    onClick={() => navigate(storeBrowsePath)}
                  >
                    Browse stores
                  </YButton>
                  <YButton type="button" variant="secondary" onClick={() => navigate('/')}>
                    Back to home
                  </YButton>
                </div>
              </div>
            </div>
          </div>
        </YPageShellBody>
      </YPageShell>
    );
  }

  return (
    <YPageShell testId="suggest-store-page" className="ss-page">
      <YPageShellHeader
        icon={<FaStore size={16} />}
        title="Suggest a Store"
        subtitle="Help grow the feed & seed directory"
      />
      <YPageShellBody>
        <div className="ss-card">
          <div className="ss-card__body">
            <p className="ss-intro">
              Add a feed or seed store for the directory. Submissions are reviewed before they go
              live in Find a Store.
            </p>
            <SuggestStoreForm
              onSuccess={() => setSubmitted(true)}
              onCancel={handleCancel}
              renderStepper={(stepIndex) => (
                <SuggestStoreStepper steps={SUGGEST_STORE_STEPS} stepIndex={stepIndex} />
              )}
            />
          </div>
        </div>
      </YPageShellBody>
    </YPageShell>
  );
}
